import React, { useContext, useState } from 'react';

import { useUserProfile } from '@atom/hooks/useUserProfile';
import { Button, TextField } from '@atom/mui';
import colors from '@atom/styles/colors';
import { AssetRequestStatus } from '@atom/types/assetRequest';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import ViewRequestContext from '../ViewRequestContext';

import ReviewStatus from './ReviewStatus';

import './ardotView.css';

const styles = {
  rejectButton: {
    width: '48%',
    border: `1px solid ${colors.neutral.ash}`,
  },
  approveButton: {
    width: '48%',
  },
  label: {
    color: colors.neutral.dim,
  },
  cancelButton: {
    marginRight: '1rem',
  },
};

const ReviewerSection = () => {
  const userProfile = useUserProfile();
  const {
    activeRequest,
    setStatus,
    setConfirmOpen,
    comments,
    setComments,
  } = useContext(ViewRequestContext);
  const [rejectView, setRejectView] = useState<boolean>(false);

  const approveClick = () => {
    setStatus(AssetRequestStatus.PENDING_APPROVAL);
    setConfirmOpen(true);
  };

  const rejectClick = () => {
    setStatus(AssetRequestStatus.REJECTED);
    setConfirmOpen(true);
  };

  const resetForm = () => {
    setRejectView(false);
    setComments(null);
  };

  const reviewer = `${activeRequest?.reviewer?.firstName} ${activeRequest?.reviewer?.lastName}`;

  const showApproveReject =
    !rejectView &&
    (userProfile?.userId === activeRequest?.reviewer?.id ||
      hasRolePermissions(ROLE_SETS.ORG_ADMIN)) &&
    activeRequest?.status === AssetRequestStatus.PENDING_REVIEW;
  const showComments =
    !isNilOrEmpty(activeRequest?.comments) &&
    isNilOrEmpty(activeRequest?.receiveDate) &&
    !isNilOrEmpty(activeRequest?.reviewDate);

  return (
    <div styleName="approval-container">
      <div styleName="step-title">Step 1: District/Division Review</div>
      <div>
        <div styleName="row-title">Reviewer (Division or District Head)</div>
        <div>{reviewer}</div>
      </div>
      {showComments && (
        <div styleName="view-row">
          <div styleName="row-title">Comments</div>
          <div>{activeRequest?.comments}</div>
        </div>
      )}
      <ReviewStatus />
      {rejectView && (
        <>
          <div styleName="input-row">
            <TextField
              InputLabelProps={{ style: styles.label }}
              fullWidth
              value={comments}
              label="Comments (optional)"
              onChange={event => setComments(event.target.value)}
            />
          </div>
          <div styleName="approve-buttons">
            <Button style={styles.cancelButton} onClick={resetForm}>
              Cancel
            </Button>
            <Button color="error" variant="contained" onClick={rejectClick}>
              Reject
            </Button>
          </div>
        </>
      )}
      {showApproveReject && (
        <div styleName="sub-buttons">
          <Button
            style={styles.rejectButton}
            onClick={() => setRejectView(true)}
          >
            Reject
          </Button>
          <Button
            style={styles.approveButton}
            color="primary"
            variant="contained"
            onClick={approveClick}
          >
            Approve
          </Button>
        </div>
      )}
    </div>
  );
};

export default ReviewerSection;
